// Widget: JobOffer List

import './index.scss';
import jQuery from 'jquery'; var $ = jQuery;
import anime from 'animejs/lib/anime.es.js';

export default class OffersList {
    constructor(root) {
        this.root = $(root);

        this.activities = activities;
        this.locations = locations;
        this.offers = offers;
        this.workingTimeModels = workingTimeModels;
        this.jobs = jobs;
        this.schoolDegrees = schoolDegrees;
        this.startingTimes = startingTimes;
        this.jobExperiences = jobExperiences;
        this.employmentForms = employmentForms;

        this.filters = this.root.find('.filters');
        this.filtersNotice = this.root.find('.filters-notice');
        this.resultsNotice = this.root.find('.results-notice');
        this.list = this.root.find('.list');

        this.initFilters();
        this.updateList(this.offers);

        this.form = this.root.find('#filters');
        this.form.on('change', this.applyFilters.bind(this));
        this.tags = this.root.find('#tags');

        this.wfjb = document.querySelector('.widget-fallback-joboffer-box');

        const params = new URLSearchParams(window.location.search);
        const options = JSON.parse((params).get('options'));
        this.presetFilters(options);

        const openform = (params).get('openform');
        if (openform) {
            const fb = this.wfjb.querySelector('.fallback__button');
            if (fb) { fb.click(); }
        }
    }

    // Filters: Options

    setFilterOption(name, value) {
        let checkbox = this.form.find('[name="' + name + '"][value="' + value + '"]');
        if (checkbox.length && checkbox.get(0).checked == false) { checkbox.click(); }
    }

    unsetFilterOption(name, value) {
        let checkbox = this.form.find('[name="' + name + '"][value="' + value + '"]');
        if (checkbox.length && checkbox.get(0).checked == true) { checkbox.click(); }
    }

    unsetAllFilterOptions() {
      this.form.find('input').each((_, checkbox) => {
        if (checkbox.checked == true) {
          checkbox.checked = false;
        }
      });
    }

    // Filters: Init

    initFilters() {
        let filterCount = 0;
        let html = '<form id="filters" class="filters-form" data-expanded="false">';

        if (this.locations.length) {
            filterCount += 1;

            html += '<div class="filter-wrap">'
                + '<div class="filter" data-type="locations">'
                + '<a href="javascript:;"><span>Unternehmensbereich</span><i class="icon-chevron-down"></i></a>'
                + '<fieldset>';

            this.locations.forEach((item) => {
                html += '<label class="checkbox">'
                    + '<input type="checkbox" id="' + item.name + '" name="locations[]" value="' + item.uid + '">'
                    + '<span>' + item.name + '</span>'
                    + '</label>';
            });

            html += '</fieldset>'
                + '</div>' /* .filter */
                + '</div>' /* .filter-wrap */;
        }

        if (this.activities.length) {
            filterCount += 1;

            html += '<div class="filter-wrap">'
                + '<div class="filter" data-type="activities">'
                + '<a href="javascript:;"><span>Tätigkeitsfeld</span><i class="icon-chevron-down"></i></a>'
                + '<fieldset>';

            this.activities.forEach((item) => {
                html += '<label class="checkbox">'
                    + '<input type="checkbox" id="' + item.name + '" name="activities[]" value="' + item.uid + '">'
                    + '<span>' + item.name + '</span>'
                    + '</label>';
            });

            html += '</fieldset>'
                + '</div>' /* .filter */
                + '</div>' /* .filter-wrap */;
        }

        if (this.workingTimeModels.length) {
            filterCount += 1;

            html += '<div class="filter-wrap">'
                + '<div class="filter" data-type="workingTimeModels">'
                + '<a href="javascript:;"><span>Arbeitszeitmodell</span><i class="icon-chevron-down"></i></a>'
                + '<fieldset>';

            this.workingTimeModels.forEach((item) => {
                html += '<label class="checkbox">'
                    + '<input type="checkbox" id="' + item.name + '" name="workingTimeModels[]" value="' + item.uid + '">'
                    + '<span>' + item.name + '</span>'
                    + '</label>';
            });

            html += '</fieldset>'
                + '</div>' /* .filter */
                + '</div>' /* .filter-wrap */;
        }

        if (this.jobs.length) {
            filterCount += 1;

            html += '<div class="filter-wrap hidden" data-hidden-by-default="true">'
                + '<div class="filter" data-type="jobs">'
                + '<a href="javascript:;"><span>Job</span><i class="icon-chevron-down"></i></a>'
                + '<fieldset>';

            this.jobs.forEach((item) => {
                html += '<label class="checkbox">'
                    + '<input type="checkbox" id="' + item.name + '" name="jobs[]" value="' + item.uid + '">'
                    + '<span>' + item.name + '</span>'
                    + '</label>';
            });

            html += '</fieldset>'
                + '</div>' /* .filter */
                + '</div>' /* .filter-wrap */;
        }

        if (this.schoolDegrees.length) {
            filterCount += 1;

            html += '<div class="filter-wrap hidden" data-hidden-by-default="true">'
                + '<div class="filter" data-type="schoolDegrees">'
                + '<a href="javascript:;"><span>Schulabschluss</span><i class="icon-chevron-down"></i></a>'
                + '<fieldset>';

            this.schoolDegrees.forEach((item) => {
                html += '<label class="checkbox">'
                    + '<input type="checkbox" id="' + item.name + '" name="schoolDegrees[]" value="' + item.uid + '">'
                    + '<span>' + item.name + '</span>'
                    + '</label>';
            });

            html += '</fieldset>'
                + '</div>' /* .filter */
                + '</div>' /* .filter-wrap */;
        }

        if (this.startingTimes.length) {
            filterCount += 1;

            html += '<div class="filter-wrap hidden" data-hidden-by-default="true">'
                + '<div class="filter" data-type="startingTimes">'
                + '<a href="javascript:;"><span>(Einstiegs-)Zeitpunkt</span><i class="icon-chevron-down"></i></a>'
                + '<fieldset>';

            this.startingTimes.forEach((item) => {
                html += '<label class="checkbox">'
                    + '<input type="checkbox" id="' + item.name + '" name="startingTimes[]" value="' + item.uid + '">'
                    + '<span>' + item.name + '</span>'
                    + '</label>';
            });

            html += '</fieldset>'
                + '</div>' /* .filter */
                + '</div>' /* .filter-wrap */;
        }

        if (this.jobExperiences.length) {
            filterCount += 1;

            html += '<div class="filter-wrap hidden" data-hidden-by-default="true">'
                + '<div class="filter" data-type="jobExperiences">'
                + '<a href="javascript:;"><span>Berufserfahrung</span><i class="icon-chevron-down"></i></a>'
                + '<fieldset>';

            this.jobExperiences.forEach((item) => {
                html += '<label class="checkbox">'
                    + '<input type="checkbox" id="' + item.name + '" name="jobExperiences[]" value="' + item.uid + '">'
                    + '<span>' + item.name + '</span>'
                    + '</label>';
            });

            html += '</fieldset>'
                + '</div>' /* .filter */
                + '</div>' /* .filter-wrap */;
        }

        if (this.employmentForms.length) {
            filterCount += 1;

            html += '<div class="filter-wrap hidden" data-hidden-by-default="true">'
                + '<div class="filter" data-type="employmentForms">'
                + '<a href="javascript:;"><span>Anstellungsart</span><i class="icon-chevron-down"></i></a>'
                + '<fieldset>';

            this.employmentForms.forEach((item) => {
                html += '<label class="checkbox">'
                    + '<input type="checkbox" id="' + item.name + '" name="employmentForms[]" value="' + item.uid + '">'
                    + '<span>' + item.name + '</span>'
                    + '</label>';
            });

            html += '</fieldset>'
                + '</div>' /* .filter */
                + '</div>' /* .filter-wrap */;
        }

        html += '</form>';
        html += '<div class="filter-footer">'
        html += '<div id="tags" class="tags"></div>';

        html += '<div class="filter-buttons">';
        html += '<button type="button" class="remove-filters-button"><i class="icon-revert"></i><span>Alle zurücksetzen</span></button>';
        if (filterCount > 3) {
            html += '<button type="button" class="more-filters-button"><i class="icon-plus"></i><span>Mehr Filter</span></button>';
        }
        html += '</div>';

        html += '</div>';

        this.filters.html(html);

        this.filters.find('.filter-wrap').each((_, wrap) => {
            const anchor = $(wrap).find('a');
            const fieldset = $(wrap).find('fieldset');

            anchor.on('click', (event) => {
                event.preventDefault();
                if (fieldset.is(":hidden")) {
                    fieldset.show();
                } else {
                    fieldset.hide();
                }
            });

            $('body').on('click', (event) => {
                if (!$(wrap).has(event.target).length) {
                    fieldset.hide();
                }
            });
        });

        this.filters.find('.remove-filters-button').on('click', (_) => {
            this.unsetAllFilterOptions();
            this.applyFilters();
        });

        this.moreFiltersButton = this.filters.find('.more-filters-button').get(0);
        if (this.moreFiltersButton) {
            this.moreFiltersButton.addEventListener('click', (_) => {
                let form = this.form[0];
                let heightFrom = form.scrollHeight;

                if (this.form.data('expanded') == false) {
                    form.style.height = heightFrom + 'px';
                    form.style.overflow = 'hidden';
                    this.form.find('.filter-wrap[data-hidden-by-default=true]').each((_, element) => {
                        element.classList.remove('hidden');
                    });
                    this.moreFiltersButton.innerHTML = '<i class="icon-minus"></i><span>Weniger Filter</span>';
                    this.form.data('expanded', true);

                    anime({
                        targets: form,
                        height: [heightFrom, form.scrollHeight],
                        duration: 200,
                        easing: 'linear',
                        complete: (_) => {
                          form.style.height = 'auto';
                          form.style.overflow = 'visible';
                        }
                    });
                } else {
                    form.style.height = 'auto';
                    this.form.find('.filter-wrap[data-hidden-by-default=true]').each((_, element) => {
                        element.classList.add('hidden');
                    });
                    this.moreFiltersButton.innerHTML = '<i class="icon-plus"></i><span>Mehr Filter</span>';
                    this.form.data('expanded', false);
                    let heightTo = form.scrollHeight;
                    form.style.height = heightFrom + 'px';

                    anime({
                        targets: form,
                        height: [heightFrom, heightTo],
                        duration: 200,
                        easing: 'linear',
                        complete: (_) => {
                          form.style.height = 'auto';
                        }
                    });
                }
            });
        }
    }

    // Results

    presetFilters(options) {
        if (!options) { return; }

        let success = [];
        success.push(this.presetSingleFilter(options['activities'], this.activities, 'activities[]'));
        success.push(this.presetSingleFilter(options['jobExperiences'], this.jobExperiences, 'jobExperiences[]'));

        if (success.some(value => !value)) {
            this.updateListState('no-filters');
        }
    }

    presetSingleFilter(ids, els, type) {
        let success = false;

        if (ids && ids.length > 0) {
            ids.forEach((id) => {
                if (els.find(el => el.uid == id)) {
                    this.setFilterOption(type, id);
                    success = true;
                }
            });
        } else {
            success = true;
        }

        return success;
    }

    updateFilterState(type, length) {
        const filter = this.root.find('[data-type="' + type + '"]');

        if (length) {
            filter.addClass('filter--selected');
        } else {
            filter.removeClass('filter--selected');
        }
    }

    updateList(offers) {
        let html = '';

        offers.forEach((item) => {
            html += '<a href="' + item.url + '" class="item">';

            if (item.locations.length > 0) {
                const loc = item.locations[0];
                html += '<div class="item__place item__place--' + loc.color + '">' + loc.name + '</div>';
            }

            html += '<div class="item__title">' + item.title + '</div>';

            html += '<div class="item__info">';
            html += '<div class="item__working-time-models">';
            item.workingTimeModels.forEach((wtm) => {
                html += '<i class="icon-clock"></i><span>' + wtm.name + '</span>';
            });
            html += '</div>';
            html += '</div>';

            html += '</a>';
        });

        this.list.html(html);

        if (offers.length != 0) {
            this.resultsNotice.html(offers.length + ' Ergebnisse');
            this.updateListState('default');
        } else {
            this.resultsNotice.html('Keine Ergebnisse');
            this.updateListState('no-results');
        }
    }

    updateListState(state) {
        switch (state) {
            case "no-filters":
                if (this.wfjb) {
                    this.filters.hide();
                    this.filtersNotice.hide();
                    this.resultsNotice.hide();
                    this.list.hide();

                    this.wfjb.classList.remove('no-results');
                    this.wfjb.classList.add('no-filters');
                } else {
                    this.filters.show();
                    this.filtersNotice.show();
                    this.resultsNotice.show();
                    this.list.show();
                }

                break;

            case "no-results":
                this.filters.show();
                this.filtersNotice.hide();
                this.list.show();

                if (this.wfjb) {
                    this.resultsNotice.hide();

                    this.wfjb.classList.remove('no-filters');
                    this.wfjb.classList.add('no-results');
                } else {
                    this.resultsNotice.show();
                }

                break;

            default:
                this.filters.show();
                this.filtersNotice.hide();
                this.resultsNotice.show();
                this.list.show();

                if (this.wfjb) {
                    this.wfjb.classList.remove('no-filters');
                    this.wfjb.classList.remove('no-results');
                }
        }
    }

    // Tags

    addTags(name, uids, list) {
        list.forEach((item) => {
            if (uids.includes(item.uid)) {
                let tag = $('<div class="tag">'
                    + '<span>' + item.name + '</span>'
                    + '<i class="icon-close"></i>'
                    + '</div>');
                tag.on('click', () => {
                    this.unsetFilterOption(name, item.uid);
                });

                this.tags.append(tag);
            }
        });
    }

    removeAllTags() {
        this.tags.html('');
    }

    // Filters: Apply

    applyFilters() {
        let filters = this.form.serializeArray();

        let activityUids = [];
        let locationUids = [];
        let workingTimeModelUids = [];
        let jobUids = [];
        let schoolDegreeUids = [];
        let startingTimeUids = [];
        let jobExperienceUids = [];
        let employmentFormUids = [];

        filters.forEach((filter) => {
            if (filter.name == 'activities[]') {
                activityUids.push(parseInt(filter.value));
            } else if (filter.name == 'locations[]') {
                locationUids.push(parseInt(filter.value));
            } else if (filter.name == 'workingTimeModels[]') {
                workingTimeModelUids.push(parseInt(filter.value));
            } else if (filter.name == 'jobs[]') {
                jobUids.push(parseInt(filter.value));
            } else if (filter.name == 'schoolDegrees[]') {
                schoolDegreeUids.push(parseInt(filter.value));
            } else if (filter.name == 'startingTimes[]') {
                startingTimeUids.push(parseInt(filter.value));
            } else if (filter.name == 'jobExperiences[]') {
                jobExperienceUids.push(parseInt(filter.value));
            } else if (filter.name == 'employmentForms[]') {
                employmentFormUids.push(parseInt(filter.value));
            }
        });

        this.updateFilterState('activities', activityUids.length);
        this.updateFilterState('locations', locationUids.length);
        this.updateFilterState('workingTimeModels', workingTimeModelUids.length);
        this.updateFilterState('jobs', jobUids.length);
        this.updateFilterState('schoolDegrees', schoolDegreeUids.length);
        this.updateFilterState('startingTimes', startingTimeUids.length);
        this.updateFilterState('jobExperiences', jobExperienceUids.length);
        this.updateFilterState('employmentForms', employmentFormUids.length);

        let results = this.offers;
        results = this.filterByActivity(activityUids, results);
        results = this.filterByLocation(locationUids, results);
        results = this.filterByWorkingTimeModel(workingTimeModelUids, results);
        results = this.filterByJob(jobUids, results);
        results = this.filterBySchoolDegree(schoolDegreeUids, results);
        results = this.filterByStartingTime(startingTimeUids, results);
        results = this.filterByJobExperience(jobExperienceUids, results);
        results = this.filterByEmploymentForm(employmentFormUids, results);

        this.updateList(results);

        this.removeAllTags();
        this.addTags('activities[]', activityUids, this.activities);
        this.addTags('locations[]', locationUids, this.locations);
        this.addTags('workingTimeModels[]', workingTimeModelUids, this.workingTimeModels);
        this.addTags('jobs[]', jobUids, this.jobs);
        this.addTags('schoolDegrees[]', schoolDegreeUids, this.schoolDegrees);
        this.addTags('startingTimes[]', startingTimeUids, this.startingTimes);
        this.addTags('jobExperiences[]', jobExperienceUids, this.jobExperiences);
        this.addTags('employmentForms[]', employmentFormUids, this.employmentForms);
    }

    // Filters: Filter By

    filterByActivity(uids, offers) {
        if (uids <= 0) { return offers; }

        let results = [];

        offers.forEach((offer) => {
            offer.activities.forEach((item) => {
                if (uids.includes(item.uid)) { results.push(offer); }
            });
        });

        return results;
    }

    filterByLocation(uids, offers) {
        if (uids <= 0) { return offers; }

        let results = [];

        offers.forEach((offer) => {
            offer.locations.forEach((item) => {
                if (uids.includes(item.uid)) { results.push(offer); }
            });
        });

        return results;
    }

    filterByWorkingTimeModel(uids, offers) {
        if (uids <= 0) { return offers; }

        let results = [];

        offers.forEach((offer) => {
            offer.workingTimeModels.forEach((item) => {
                if (uids.includes(item.uid)) { results.push(offer); }
            });
        });

        return results;
    }

    filterByJob(uids, offers) {
        if (uids <= 0) { return offers; }

        let results = [];

        offers.forEach((offer) => {
            offer.jobs.forEach((item) => {
                if (uids.includes(item.uid)) { results.push(offer); }
            });
        });

        return results;
    }

    filterBySchoolDegree(uids, offers) {
        if (uids <= 0) { return offers; }

        let results = [];

        offers.forEach((offer) => {
            offer.schoolDegrees.forEach((item) => {
                if (uids.includes(item.uid)) { results.push(offer); }
            });
        });

        return results;
    }

    filterByStartingTime(uids, offers) {
        if (uids <= 0) { return offers; }

        let results = [];

        offers.forEach((offer) => {
            offer.startingTimes.forEach((item) => {
                if (uids.includes(item.uid)) { results.push(offer); }
            });
        });

        return results;
    }

    filterByJobExperience(uids, offers) {
        if (uids <= 0) { return offers; }

        let results = [];

        offers.forEach((offer) => {
            offer.jobExperiences.forEach((item) => {
                if (uids.includes(item.uid)) { results.push(offer); }
            });
        });

        return results;
    }

    filterByEmploymentForm(uids, offers) {
        if (uids <= 0) { return offers; }

        let results = [];

        offers.forEach((offer) => {
            offer.employmentForms.forEach((item) => {
                if (uids.includes(item.uid)) { results.push(offer); }
            });
        });

        return results;
    }
}
